import Analytics from '@module/analytics';
import { getTCString } from './tc-model';

function track(params) {
  // Use GA for third party verification
  Analytics.trackGoogleEvent(params);

  // By default, pass along tcstring
  params.property = getTCString();
  Analytics.trackSnowplowEvent(params);
}

export function acceptAll(context) {
  track({
    category: 'cmp',
    action: 'click_accept_all',
    label: context,
  });
}

export function rejectAll(context) {
  track({
    category: 'cmp',
    action: 'click_reject_all',
    label: context,
  });
}

export function save(context) {
  track({
    category: 'cmp',
    action: 'click_save_exit',
    label: context,
  });
}

export function clickLegal() {
  track({
    category: 'cmp',
    action: 'click_legal',
  });
}

export function clickPrivacyPreferences() {
  track({
    category: 'cmp',
    action: 'click_privacy_preferences',
  });
}

export function showModal() {
  track({
    category: 'cmp',
    action: 'show_modal',
  });
}

export function rejectedTrackingFromPreviousCookiewall() {
  track({
    category: 'cmp',
    action: 'rejected_tracking_before',
  });
}
